module.exports = __webpack_public_path__ + "img/nt52-01-80-1.prt.9bda9e38.jpg";